<template lang="pug">
	.merchant-application
		.section.section--white
			MerchantApplicationForm(
				ref="form",
				v-show="formState==FORM_STATES.FORM",
				:settlements="settlements",
				:captcha-img="captcha.htmlFragment",
				:captcha-error="captchaError",
				:conditions-modal-id="conditionsModalId",
				:privacy-statement-url="privacyStatementUrl",
				@captcha-keyup="resetCaptchaError",
				@zip-change="getSettlements",
				@submit="send"
			)
			MerchantApplicationSuccess(v-if="formState==FORM_STATES.SUCCESS")
			MerchantApplicationError(v-if="formState==FORM_STATES.TECHNICAL_ERROR", @try-again="backToForm")
</template>

<script>
import MerchantApplicationForm from './merchant-application-form/merchant-application-form.vue';
import MerchantApplicationSuccess from './merchant-application-success/merchant-application-success.vue';
import MerchantApplicationError from './merchant-application-error/merchant-application-error.vue';
import MerchantApplicationApi from '../../api/merchants-api';
import PostCodesApi from '../../api/postcodes-api';
import CaptchaApi from '../../api/captcha-api';
import { FORM_STATES } from '../../common/js/constants/constants';
const CAPTCHA_ID = 'DONATION_APPLY';
export default {
	data: () => ({
		formState: FORM_STATES.FORM,
		settlements: null,
		organizationTypes: null,
		loading: false,
		captcha: {
			captchaKey: null,
			htmlFragment: null
		},
		captchaError: false
	}),
	components: {
		MerchantApplicationForm,
		MerchantApplicationError,
		MerchantApplicationSuccess
	},
	props: {
		conditionsModalId: {
			required: false,
			type: String,
			default: 'feltetelek'
		},
		privacyStatementUrl: {
			required: false,
			type: String
		}
	},
	computed: {
		FORM_STATES: () => FORM_STATES
	},
	methods: {
		async getSettlements(zipCode) {
			try {
				const response = await PostCodesApi.getSettlements(zipCode);
				this.settlements = response.data.map(settlement => settlement.settlement);
			} catch (err) {
				this.formState = FORM_STATES.TECHNICAL_ERROR;
			}
		},
		backToForm() {
			this.formState = FORM_STATES.FORM;
			this.resetCaptcha();
		},
		resetCaptcha() {
			this.$refs.form.resetCaptcha();
			this.generateCaptcha(CAPTCHA_ID);
		},
		resetCaptchaError() {
			this.captchaError = false;
		},
		async send(data) {
			try {
				this.loading = true;
				this.captchaError = false;
				const dataToSend = Object.assign({}, data, { captchaKey: this.captcha.captchaKey, url: window.location.href });
				await MerchantApplicationApi.submit(dataToSend);
				this.$gtm.trackEvent({ event: 'grantApplicationSuccess' });
				this.formState = FORM_STATES.SUCCESS;
			} catch (err) {
				if (err.response.status == 400) {
					if (err.response.data && err.response.data.errors && err.response.data.errors == 'captchaText') {
						this.captchaError = true;
						this.resetCaptcha();
					} else if (err.response.data) {
						this.$gtm.trackEvent({ event: 'grantApplicationFailed' });
						this.formState = FORM_STATES.TECHNICAL_ERROR;
					}
				} else {
					this.$gtm.trackEvent({ event: 'grantApplicationFailed' });
					this.formState = FORM_STATES.TECHNICAL_ERROR;
				}
			} finally {
				this.loading = false;
			}
		},
		async generateCaptcha() {
			try {
				const response = await CaptchaApi.generateCaptcha(CAPTCHA_ID);
				this.captcha = response.data;
			} catch (err) {
				this.formState = FORM_STATES.TECHNICAL_ERROR;
			}
		}
	},
	created() {
		this.generateCaptcha();
	}
};
</script>

<style lang="scss" scoped>
@import '@ui-common/sf-style-utils/lib/helpers/_colors.scss';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';
</style>
